import React from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Row, Col} from 'reactstrap';
import styles from '@/b2b/index.module.css';
import {Text} from '@/Form';

const SearchBox = ({producerName}) => {
  const {t: tr} = useTranslation();
  return (
    <Card>
      <CardBody className={styles.search_box_body}>
        <Row>
          <Col md={10}>
            <Text
              name='producerName'
              label={tr('consultant')}
              value={producerName}
              readOnly
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default SearchBox;
